(ns hai.tasks.history
  "How a change in a task's history reads: the parts the platform says a change
   touched (`:task.change/parts` of `:task/history`), and whom a change of
   assignee gave the task to, as words."
  (:require
   [clojure.string :as str]))

(def ^:private edited-names
  {:task.change/title "title"
   :task.change/description "description"})

(def ^:private changed-names
  {:task.change/deadline "due date"
   :task.change/urgency "urgency"
   :task.change/links "links"
   :task.change/related "related items"})

(defn- listed
  "`names` as a phrase: \"a\", \"a and b\", \"a, b and c\"."
  [names]
  (if (next names)
    (str (str/join ", " (butlast names)) " and " (last names))
    (first names)))

(defn- assignee-clause
  "A change of assignee as words: whom it gave the task to, `to` already in
   words (\"you\", \"Alice\"), and whether someone had it before, or that it
   left the task with nobody."
  [{:keys [to reassigned?]}]
  (cond
    (nil? to) "unassigned"
    reassigned? (str "reassigned to " to)
    :else (str "assigned to " to)))

(defn- capitalised
  "`s` with its first letter upper-cased and the rest as they are, so a name
   in it keeps its own."
  [s]
  (str (str/upper-case (subs s 0 1)) (subs s 1)))

(defn change-text
  "What a change's `parts` say happened, as a sentence without its full stop:
   \"Created\", \"Edited the title and description\", \"Completed, changed the
   due date\", \"Reassigned to Alice\". `assignee` describes a change of
   assignee, as [[assignee-clause]] reads it. A change with no part it knows
   reads \"Changed\"."
  [parts assignee]
  (let [touched? (set parts)
        edited (keep edited-names parts)
        changed (keep changed-names parts)
        clauses (cond-> []
                  (touched? :task.change/created) (conj "created")
                  (touched? :task.change/completed) (conj "completed")
                  (touched? :task.change/reopened) (conj "reopened")
                  (seq edited) (conj (str "edited the " (listed edited)))
                  (seq changed) (conj (str "changed the " (listed changed)))
                  (touched? :task.change/assignee) (conj (assignee-clause assignee)))]
    (if (seq clauses)
      (capitalised (str/join ", " clauses))
      "Changed")))
